import React from "react";
import { SEText } from "../SEText";
import { Button } from "@mui/material";

interface SEButtonProps {
  selected?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  textStyle?: React.CSSProperties;
}
export const SEButton: React.FC<SEButtonProps> = ({
  onClick,
  selected,
  children,
  textStyle,
}) => {
  return (
    <Button
      type={"button"}
      onClick={onClick}
      sx={{
        display: "flex",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontWeight: selected ? "bold" : "inherit",
        textTransform: "inherit",
      }}
    >
      <SEText
        font={"Mulish"}
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "8px",
          ...textStyle,
        }}
      >
        {children}
      </SEText>
    </Button>
  );
};
